export const placeRequests = (requestor: any) => ({
  createPlace: async (data: any) => {
    const url = `/places/create`;
    const formData = new FormData();
    formData.append('name', data.name);
    if (data.descriptionTitle) formData.append('descriptionTitle', data.descriptionTitle);
    formData.append('description', data.description);
    formData.append('location', data.location);
    formData.append('country', data.country);
    if (data.file) formData.append('file', data.file);
    if (data.blocks) formData.append('blocks', JSON.stringify(data.blocks));
    return requestor({ method: 'POST', url, data: formData });
  },

  editPlace: async (data: any, id: string) => {
    const url = `/places/update/${id}`;
    const formData = new FormData();
    formData.append('name', data.name);
    if (data.descriptionTitle) formData.append('descriptionTitle', data.descriptionTitle);
    formData.append('description', data.description);
    formData.append('location', data.location);
    formData.append('country', data.country);
    if (data.file) formData.append('file', data.file);
    if (data.blocks) formData.append('blocks', JSON.stringify(data.blocks));
    return requestor({ method: 'PATCH', url, data: formData });
  },

  deletePlace: async (id: string) => requestor({ method: 'DELETE', url: `/places/delete/${id}` }),

  get: {
    getAllPlaces: async () => requestor({ method: 'GET', url: `/places/getAllPlaces` }),
    getPlacesByCountry: async (countryId: string) => requestor({ method: 'GET', url: `/places/getByCountry/${countryId}` }),
    getPlaceById: async (id: string) => requestor({ method: 'GET', url: `/places/${id}` }),
    getPlaceBySlug: async (slug: string) => requestor({ method: 'GET', url: `/places/getBySlug/${slug}` }),
  },
});
